import axios from "../javascript/custom-axios";
let RESOURCE_NAME = "PriceListLimit";

export default {
  /**
   * Get price list limits with pagination.
   * @param {{ Page: number, PageSize: number }} params
   * @returns {Promise<any>}
   */
  getAll(params) {
    return axios.get(RESOURCE_NAME, { params });
  },

  /**
   * Add a new price list limit.
   * @param {{ Weight: number, Circumference: number, LongestSideLength: number, IntegrationServiceId: string }} data
   * @returns {Promise<any>}
   */
  add(data) {
    return axios.post(RESOURCE_NAME, data);
  },

  /**
   * Update an existing price list limit.
   * @param {{ Id: string, Weight: number, Circumference: number, LongestSideLength: number }} data
   * @returns {Promise<any>}
   */
  update(data) {
    return axios.put(RESOURCE_NAME, data);
  },

  /**
   * Delete a price list limit.
   * @param {string} id
   * @returns {Promise<any>}
   */
  delete(id) {
    return axios.delete(`${RESOURCE_NAME}/${id}`);
  },
};
